import { Action } from '@ngrx/store';
import {FirmWareLog, FirmWareLogParams} from '../firm-ware.model';

export enum FirmWareUpdatingDataActionTypes {
  GetFirmWareUpdatingDatas = '[FirmWareUpdatingData] Get FirmWareUpdatingDatas',
  GetDelayFirmWareUpdatingDatas = '[FirmWareUpdatingData] Get Delay FirmWareUpdatingDatas',
  LoadFirmWareUpdatingDatas = '[FirmWareUpdatingData] Load FirmWareUpdatingDatas',
  UpsertFirmWareUpdatingDatas = '[FirmWareUpdatingData] Upsert FirmWareUpdatingDatas',
  ClearFirmWareUpdatingDatas = '[FirmWareUpdatingData] Clear FirmWareUpdatingDatas',
}

export class GetFirmWareUpdatingDatas implements Action {
  readonly type = FirmWareUpdatingDataActionTypes.GetFirmWareUpdatingDatas;
  constructor(public payload: any = null) {}
}

export class GetDelayFirmWareUpdatingDatas implements Action {
  readonly type = FirmWareUpdatingDataActionTypes.GetDelayFirmWareUpdatingDatas;
  constructor(public payload: FirmWareLogParams) {}
}

export class LoadFirmWareUpdatingDatas implements Action {
  readonly type = FirmWareUpdatingDataActionTypes.LoadFirmWareUpdatingDatas;
  constructor(public payload: FirmWareLog[]) {}
}

export class UpsertFirmWareUpdatingDatas implements Action {
  readonly type = FirmWareUpdatingDataActionTypes.UpsertFirmWareUpdatingDatas;
  constructor(public payload: FirmWareLog[]) {}
}

export class ClearFirmWareUpdatingDatas implements Action {
  readonly type = FirmWareUpdatingDataActionTypes.ClearFirmWareUpdatingDatas;
}


export type FirmWareUpdatingDataActions = LoadFirmWareUpdatingDatas
  | UpsertFirmWareUpdatingDatas
  | GetFirmWareUpdatingDatas
  | ClearFirmWareUpdatingDatas
  | GetDelayFirmWareUpdatingDatas;

